import { ReactNode, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authApi } from '../api';

export function AuthGuard({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [state, setState] = useState<'loading'|'ok'|'no'>('loading');
  useEffect(() => { authApi.me().then(() => setState('ok')).catch(() => setState('no')); }, []);
  if (state === 'loading') return <div className="auth-loading">正在开启控制台…</div>;
  if (state === 'no') return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
}
